import React, { useState } from "react";
import { MdNavigateBefore, MdNavigateNext } from "react-icons/md";
import { useMediaQuery } from "react-responsive";

const PaginationComponent = ({
  currentPage,
  totalPages,
  onPageChange,
  handleKeyPress,
  handleGoToPage,
  setPerPageLimit,
  perPageLimit = 25,
}) => {
  const isMobile = useMediaQuery({ query: "(max-width:576px)" });
  // const isTab = useMediaQuery({ query: "(max-width:1024px)" });
  const [pageNo, setPageNo] = useState("");

  const getPageNumbers = () => {
    const pageNumbers = [];
    for (let i = 1; i <= totalPages; i++) {
      pageNumbers.push(i);
    }
    return pageNumbers;
  };
  // //(currentPage, totalPages, 'hshkskka')
  const handlePageChange = (pageNumber) => {
    // //(pageNumber, 'dkjsldask')
    if (
      pageNumber !== currentPage &&
      pageNumber > 0 &&
      pageNumber <= totalPages
    ) {
      onPageChange(pageNumber);
    }
  };

  const renderPageNumbers = () => {
    const pageNumbers = getPageNumbers();
    const visiblePages = [];
    const range = isMobile ? 1 : 2; // Adjusted range for mobile

    if (totalPages <= 3) {
      visiblePages.push(...pageNumbers);
    } else {
      if (currentPage <= 2) {
        visiblePages.push(...pageNumbers.slice(0, 3), "ellipsis", totalPages);
      } else if (currentPage >= totalPages - 1) {
        visiblePages.push(
          1,
          "ellipsis",
          ...pageNumbers.slice(totalPages - 3, totalPages)
        );
      } else {
        visiblePages.push(
          1,
          "ellipsis",
          ...pageNumbers.slice(currentPage - range, currentPage + range),
          "ellipsis",
          totalPages
        );
      }
    }

    return visiblePages.map((pageNumber, index) => {
      if (pageNumber === "ellipsis") {
        return (
          <div key={index} className="px-2 lg:pt-2 font-bold">
            ...
          </div>
        );
      }
      return (
        <button
          key={index}
          onClick={() => handlePageChange(pageNumber)}
          className={`w-[40px] h-[40px] lg:w-[29.63px] lg:h-[29.63px] lg:text-[13.27px] xl:w-[37.04px] xl:h-[37.04px] xl:text-[16.59px] 2xl:w-[39.53px] 2xl:-[39.53px] 2xl:text-[17.71px] min-[1920]:w-[55.56px] min-[1920]:h-[55.56px] min-[1920]:text-[24.89px] md:w-[50px] md:h-[50px] text-lg md:text-xl lg:text-2xl rounded-full ${
            currentPage === pageNumber
              ? "bg-green-200 font-bold"
              : "text-gray-700 hover:bg-gray-200"
          }`}
          style={{
            backgroundColor: currentPage === pageNumber ? "#C7EAC9" : "",
            border: currentPage === pageNumber ? "1px solid #C7EAC9" : "",
            fontWeight: currentPage === pageNumber ? "bold" : "normal",
            marginRight: isMobile ? "5px" : "10px",
            marginLeft: isMobile ? "5px" : "10px",
          }}
        >
          {pageNumber}
        </button>
      );
    });
  };

  const handlePerPageChange = (e) => {
    setPerPageLimit(parseInt(e.target.value));
  };

  return (
    <div className="flex flex-col sm:flex-row items-center justify-between gap-2 sm:gap-0 mt-2 sm:mt-0">
      <div></div>
      <div className="flex items-center m-auto sm:ml-auto">
        <div className="flex items-center justify-center space-x-2 mt-4">
          <button
            onClick={() => handlePageChange(currentPage - 1)}
            className={`${isMobile ? "px-1" : "px-3"} py-1 ${
              currentPage === 1 ? "cursor-not-allowed" : ""
            } font-bold`}
            disabled={currentPage === 1}
          >
            <MdNavigateBefore className="text-[20.74px] text-3xl" />
          </button>
          {renderPageNumbers()}
          <button
            onClick={() => handlePageChange(currentPage + 1)}
            className={` ${isMobile ? "px-1" : "px-3"} ${
              currentPage === totalPages ? "cursor-not-allowed " : ""
            }font-bold`}
            disabled={currentPage === totalPages}
          >
            <MdNavigateNext className="text-[20.74px] text-3xl" />
          </button>
        </div>

        <div className="w-[71.7px] h-[28.85px] min-[1920px]:w-[134.44px] min-[1920px]:h-[54.22px] xl:w-[89.63px] xl:h-[35.81px] items-center border border-[#E2E1E5] mt-3 rounded hidden md:flex">
          <input
            className="outline-none h-full pl-2 flex-1"
            type="number"
            min="1"
            max={totalPages}
            placeholder="Go to page"
            onChange={(e) => setPageNo(e.target.value)}
            onKeyDown={handleKeyPress}
          />
          <span>
            <MdNavigateNext
              className="cursor-pointer"
              color="#5B5B5B"
              size={19}
              onClick={() => handleGoToPage(Number(pageNo))}
            />
          </span>
        </div>
      </div>

      <div className="flex gap-2 items-center  min-[1920px]:h-[54.22px] xl:h-[35.81px]">
        <label htmlFor="perPage" className="text-sm md:text-base">
          Page Limit:
        </label>
        <div className="border border-gray-300 rounded-md shadow-sm px-2">
          <select
            id="perPage"
            className="w-16 md:sm-20 h-full py-2 text-sm md:text-base rounded-md shadow-sm focus:outline-none focus:border-blue-500"
            value={perPageLimit}
            onChange={handlePerPageChange}
          >
            <option value={25}>25</option>
            <option value={30}>30</option>
            <option value={35}>35</option>
            <option value={40}>40</option>
            <option value={45}>45</option>
            <option value={50}>50</option>
            <option value={100}>100</option>
            <option value={500}>500</option>
            <option value={1000}>1000</option>
          </select>
        </div>
      </div>
    </div>
  );
};

export default PaginationComponent;
